import * as PIXI from "pixi.js";

export function loadMask({ parent, renderer }) {
  var mask = new PIXI.Graphics();
  mask.beginFill(0x000000, 0.6);
  mask.drawRect(0, 0, renderer.width, renderer.height);
  mask.endFill();
  mask.zIndex = 2;
  mask.interactive = true;
  mask.isMask = true;

  parent.addChild(mask);
  return mask;
}
